<template>
  <ClientOnly>
    <div :class="wrapperClass" v-if="isSupported">
      <button class="w-full" @click="copy(profileLink)">
        <div
          :class="btnClass"
          class="flex items-center justify-center space-x-1.5 bg-gray-100 text-primary hover:bg-gray-200/75 transition-all duration-300 cursor-pointer"
        >
          <p>
            {{ copied ? $t("common.copied_link") : $t("common.copy_link") }}
          </p>
          <Icon
            :name="copied ? 'ph:check-circle' : 'ph:link'"
            class="text-lg"
          />
        </div>
      </button>
    </div>
  </ClientOnly>
</template>

<script setup lang="ts">
import { useClipboard } from "@vueuse/core";

const { copy, copied, isSupported } = useClipboard();

withDefaults(
  defineProps<{
    profileLink: string;
    btnClass?: string;
    wrapperClass?: string;
  }>(),
  {
    btnClass: "sm:w-fit w-full px-2.5 h-9",
    wrapperClass: "sm:pt-0 pt-3.5",
  },
);
</script>
